import React, { useState, useEffect } from 'react';

import { SingleLink } from '../../Res/BaseButton';
import { ContentBox } from '../ContentBox';
import { ContractorAttendanceInfo_SalaryHourly } from '../../../../item/ItemContractorAttendance';

export function ContractorAttendanceEditSalaryHourly({ contractorAttendance, salaryHourly }) {
  const [mSalaryHourly, setSalaryHourly] = useState(new ContractorAttendanceInfo_SalaryHourly({}))

  useEffect(() => {
    if (salaryHourly !== undefined && mSalaryHourly !== salaryHourly) {
      console.log(salaryHourly)
      setSalaryHourly(salaryHourly)
    }
  }, [salaryHourly])

  function test(){

  }


  var title = <>出勤登錄計算-時薪-上工人數&nbsp;<span className="text-success">{mSalaryHourly.Enrolment}</span>&nbsp;人</>
  var content =
    <>
      <div id="editable_wrapper" className="form-inline dt-bootstrap">
        <div className="row">
          <div className="col-sm-12">
            <table className="table table-striped table-bordered table-hover  dataTable">
              <thead>
                <tr role="row">
                  <th className="text-center sorting col-sm-2">項目名稱</th>
                  <th className="text-right sorting col-sm-2">合計金額</th>
                  <th className="text-center sorting col-sm-2">作業時間點</th>
                  <th className="text-center sorting col-sm-2">作業</th>
                  <th className="text-left sorting col-sm-2">提示</th>
                </tr>
              </thead>
              <tbody>
                <tr role="row">
                  <td className="text-center">請款金額</td>
                  <td className="text-center">{mSalaryHourly.Pretax.Amount}</td>
                  <td className="text-center">{mSalaryHourly.Pretax.ActionTime}</td>
                  <td className="text-center">
                    <SingleLink link={"ContractorAttendanceRegisterHourly"}
                      name={"出勤及加減項登錄"}
                      Key={"salaryHourly"}
                      val={{salaryHourly: mSalaryHourly, contractorAttendance}} >
                    </SingleLink>
                    </td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">應付薪資</td>
                  <td className="text-center">{mSalaryHourly.Salary.Amount}</td>
                  <td className="text-center">{mSalaryHourly.Salary.ActionTime}</td>
                  <td className="text-center">
                    <a href="#A" onClick={e => test()} >新增至薪資發放作業</a>
                  </td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">廠商負擔保險費用</td>
                  <td className="text-center">{mSalaryHourly.InsuranceCosts.Amount}</td>
                  <td className="text-center">{mSalaryHourly.InsuranceCosts.ActionTime}</td>
                  <td className="text-center">
                    <SingleLink link={"ContractorInsuranceCostHourly"}
                      name={"保費計算"}
                      Key={"salaryHourly"}
                      val={{salaryHourly: mSalaryHourly, contractorAttendance}} >
                    </SingleLink>
                  </td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">服務費</td>
                  <td className="text-center">{mSalaryHourly.ServiceFee.Amount}</td>
                  <td className="text-center">{mSalaryHourly.ServiceFee.ActionTime}</td>
                  <td className="text-center">--</td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">營業稅</td>
                  <td className="text-center">{mSalaryHourly.Tax.Amount}</td>
                  <td className="text-center">{mSalaryHourly.Tax.ActionTime}</td>
                  <td className="text-center">--</td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">發票金額</td>
                  <td className="text-center">{mSalaryHourly.Invoice.Amount}</td>
                  <td className="text-center">{mSalaryHourly.Invoice.ActionTime}</td>
                  <td className="text-center">
                    <a href="#A" onClick={e => test()} >新增至請款作業</a>
                  </td>
                  <td className="text-center">請注意</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>

  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} hasDrawer={false} />
    </>
  )
}

